import { RouterProvider } from 'react-router-dom';

import { router } from './util/route/route';

import FallbackLoader from './component/ContentWrapper/Content/Loader/FallbackLoader';
import { useIsMobile } from './hook/useIsMobile';

import './theme/theme-light.css';
import './theme/theme-dark.css';
import { useEffect } from 'react';
import { useAppSelector } from './hook/useAppSelector';
import { applyTheme } from './theme/applyTheme';

const App: React.FC = () => {
  useIsMobile();

  const theme = useAppSelector((state) => state.configSlice.theme);

  useEffect(() => {
    applyTheme(theme);
  }, [theme]);

  return (
    <>
      <RouterProvider router={router} fallbackElement={<FallbackLoader></FallbackLoader>}></RouterProvider>
    </>
  );
};

export default App;
